import ReactEcharts from "echarts-for-react";
import React, { FC } from "react";

interface DataInterface {
  property: string;
  value: number;
}
interface MixLineChartInterface {
  data: Array<DataInterface>;
  children?: React.ReactNode;
  barWidth?: number;
  titleValue?: string;
  className?: string;
  download?: boolean;
}

export const MixLineChart: FC<MixLineChartInterface> = ({
  data,
  children,
  // barWidth,
  titleValue,
  className,
  // download,
}) => {
  const xAxisData = data?.length
    ? data?.map((item: DataInterface) => item?.property)
    : [];
  const valueData = data?.length
    ? data?.map((item: DataInterface) => item?.value)
    : [];

  const option = {
    tooltip: {
      trigger: "axis",
      axisPointer: {
        type: "cross",
        crossStyle: {
          color: "#999",
        },
      },
    },
    toolbox: {
      feature: {
        dataView: { show: false, readOnly: false },
        magicType: { show: false, type: ["line", "bar"] },
        restore: { show: false },
        saveAsImage: { show: false },
      },
    },
    // legend: {
    //   data: ["Evaporation", "Precipitation", "Temperature"],
    // },
    xAxis: [
      {
        type: "category",
        data: xAxisData,
        axisPointer: {
          type: "shadow",
        },
      },
    ],
    yAxis: [
      {
        type: "value",
        name: titleValue,
      },
      {
        type: "value",
        name: "",
        axisLabel: {
          formatter: "",
        },
      },
    ],
    series: [
      {
        name: "",
        type: "bar",
        tooltip: {
          valueFormatter: function (value: any) {
            return value + "";
          },
        },
        data: valueData,
      },
      {
        name: "",
        type: "line",
        yAxisIndex: 1,
        tooltip: {
          valueFormatter: function (value: any) {
            return value + "";
          },
        },
        data: valueData,
      },
    ],
  };
  return (
    <>
      <div className="mx-[40px] ">{children}</div>
      <ReactEcharts
        option={option}
        className={className}
        style={{ height: "350px" }}
      />
    </>
  );
};
